import React from 'react';
import { Box, CardContent, Typography, Tooltip } from '@mui/material';
import { Shield as ShieldIcon } from '@mui/icons-material';
import { C, POSITION_LABELS } from './constants';
import { GlowCard } from './ui';

/**
 * PositionsCard — shows field positions as chips with player counts.
 *
 * Props:
 *   positionMap — { [positionCode]: count }
 */
const PositionsCard = ({ positionMap = {}, delay = 0 }) => {
  const entries = Object.entries(positionMap).sort((a, b) => b[1] - a[1]);
  if (entries.length === 0) return null;

  return (
    <GlowCard delay={delay} accent={C.amber}>
      <CardContent sx={{ p: 3 }}>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2.5 }}>
          <ShieldIcon sx={{ color: C.amber, fontSize: 20 }} />
          <Typography sx={{ fontFamily: 'Syne', fontWeight: 700, color: C.text, fontSize: '1rem' }}>
            Postes de terrain
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {entries.map(([pos, cnt], i) => (
            <Tooltip
              key={pos}
              title={`${POSITION_LABELS[pos] || pos} · ${cnt} joueur${cnt > 1 ? 's' : ''}`}
              arrow
            >
              <Box sx={{
                display: 'flex', alignItems: 'center', gap: 1,
                px: 2, py: 0.8, borderRadius: '10px',
                background: `${C.amber}10`, border: `1px solid ${C.amber}25`,
                animation: `scaleIn 0.35s ease both`,
                animationDelay: `${i * 40 + delay}ms`,
                transition: 'all 0.2s', cursor: 'default',
                '&:hover': { background: `${C.amber}20`, borderColor: `${C.amber}50` },
              }}>
                <Typography sx={{ fontFamily: 'Syne', fontWeight: 700, color: C.amber, fontSize: '0.85rem' }}>
                  {pos}
                </Typography>
                <Box sx={{
                  width: 20, height: 20, borderRadius: '50%',
                  background: `${C.amber}25`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <Typography sx={{ fontFamily: 'Syne', fontWeight: 800, color: C.amber, fontSize: '0.7rem' }}>
                    {cnt}
                  </Typography>
                </Box>
              </Box>
            </Tooltip>
          ))}
        </Box>

      </CardContent>
    </GlowCard>
  );
};

export default PositionsCard;
